import React, { FC } from 'react'
import { Tab } from '@headlessui/react'
import classNames from 'classnames'
import { TitleSM } from '@/atoms/Text'
import { TAB_STYLES } from './constants'
import { TabButtonProps } from './types'

export const TabButton: FC<TabButtonProps> = ({ tab, activeTab, isActive }) => {
  const isActiveInMode = activeTab === tab?.sys.id
  const isDetailsDisabled = tab?.__typename === 'GiveawayDetailsTab' && !isActive

  if (!tab) return null

  return (
    <Tab
      disabled={isDetailsDisabled}
      className={classNames(
        TAB_STYLES.multi,
        isActiveInMode && TAB_STYLES.active,
        isDetailsDisabled && TAB_STYLES.disabled,
      )}
    >
      <TitleSM>{tab.title}</TitleSM>
    </Tab>
  )
}
